/* eslint-disable */

function Accordion(el) {
	const details = el.querySelectorAll(".details");
	let isDisable = false;

	const onclick = (detail) => {
		details.forEach(e => {
			const summary = e.querySelector('.summary');
			if (detail != e) {
				summary.setAttribute("aria-expanded", false);
				e.classList.remove("open")
			}
		});
	}

	details.forEach(detail => {
		const summary = detail.querySelector('.summary');
		const panel = detail.querySelector('.panel');

		summary.onclick = () => {
			if (isDisable) return;

			onclick(detail);

			if (summary.getAttribute("aria-expanded") == "false") {
				summary.setAttribute("aria-expanded", true);
				detail.classList.toggle("open");
				panel.querySelectorAll("a").forEach(link => link.setAttribute("tabindex", 0))
			} else {
				summary.setAttribute("aria-expanded", false);
				detail.classList.remove("open");
				panel.querySelectorAll("a").forEach(link => link.setAttribute("tabindex", -1))
			}
		}
	})

	const reset = () => {
		details.forEach(detail => {
			const summary = detail.querySelector('.summary');
			const panel = detail.querySelector('.panel');
			
			if (isDisable) {
				summary.removeAttribute("aria-expanded");
				detail.classList.remove("open");
				panel.querySelectorAll("a").forEach(link => link.removeAttribute("tabindex"))
			} else {
				summary.setAttribute("aria-expanded", false);
				detail.classList.remove("open");
				panel.querySelectorAll("a").forEach(link => link.setAttribute("tabindex", -1))
			}
		})
	}

	this.disable = () => {
		isDisable = true;
		reset();
	}

	this.enable = () => {
		isDisable = false;
		reset();
	}
}

export default Accordion;